import Axios from 'axios'
import {
    CURRENT_SUBNET,
    DEFAULT_NETWORK,
    subnet_url,
} from '@/store/modules/network/network'
import { IEVMAddressBalanceParams } from './model'

const requestHeader = {
    'Content-Type': 'application/json',
}
export async function getEVMAddressBalance(params: IEVMAddressBalanceParams) {
    let VALIDATOR_URL: string
    if (CURRENT_SUBNET !== null) {
        VALIDATOR_URL = subnet_url
    } else {
        VALIDATOR_URL = DEFAULT_NETWORK.dcommGoEthUrl
    }
    const newRes = await Axios.post(
        VALIDATOR_URL,
        JSON.stringify({
            jsonrpc: '2.0',
            method: 'eth_getBalance',
            params: [params.address, 'latest'],
            id: 1,
        }),
        {
            headers: requestHeader,
        }
    )
    return newRes
}
